import React, { useState } from 'react'

import {
  Card,
  ChevronDownIcon,
  CloseIcon,
  Col,
  IconButton,
  Row,
  TextDisplay,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { recordDynamicEvent } from '../../../components/common/analytics/utils'
import { saveBannerProgress } from '../../../utils/session-utils'
import apiFactory from '../../../utils/api-factory'

const MinimizedBanner = ({
  closeBanner,
  bannerPage,
  bannerTitle,
  productIntegration,
  setIsSavingUserPreferences,
}) => {
  const [isMinimized, setIsMinimized] = useState(false)

  const { logger, csrf, setCurrentBannerStep } = useApplicationContext()

  const clickHandler = () => {
    if (isMinimized) {
      setIsMinimized(false)
    } else {
      setIsMinimized(true)
    }
  }

  const addUserPreference = async () => {
    setIsSavingUserPreferences(true)
    const userBannerPreference = {
      preferenceName: 'ONBOARDING_BANNER',
      preferenceValue: 'CLOSED',
    }

    await apiFactory.addUserPreference(csrf, userBannerPreference)
    setIsSavingUserPreferences(false)
  }

  const closeHandler = () => {
    closeBanner(true)
    recordDynamicEvent(`onboarding_banner_close,click,${bannerPage}`)

    const sessionObject = {
      bannerPage,
      productIntegration,
      closeOnboardingBanner: true,
    }

    setCurrentBannerStep(sessionObject)
    saveBannerProgress(csrf, logger, sessionObject)
    addUserPreference()
  }

  return (
    <Card>
      <Row>
        <Col xs={10}>
          <TextDisplay
            value={<Message id={bannerTitle} />}
            className="banner-title-minimized banner-title"
          />
        </Col>
        <Col align="right">
          <IconButton
            size="sm"
            onClick={clickHandler}
            buttonType="tertiary"
            svgIconComponent={ChevronDownIcon}
          />
          <IconButton
            size="sm"
            onClick={closeHandler}
            buttonType="tertiary"
            svgIconComponent={CloseIcon}
            style={{
              marginLeft: '12px',
              marginRight: '12px',
            }}
          />
        </Col>
      </Row>
    </Card>
  )
}

export default MinimizedBanner
